import React, { useContext, useState } from "react";
import BuySellModal from "../../../modals/BuySellModal";
import { useBuySellModalContext } from "../../../context/BuySellModalContext";
import WebsocketWrapperContext from "../../../context/WebsocketWrapperContext";

const PositionsTable = ({
    positions,
    symbolData,
    handleRowMouseEnter,
    handleRowMouseLeave,
    handleCheckboxChange,
    hoveredRowIndex,
    mainIndex,
    currentGroupIndex,
    activeButton,
    visibility,
    formatNumberWithFontWeight,
}) => {
    const {
        subscribeToSymbols,
    } = useContext(WebsocketWrapperContext);
    const { setBuySellModalData } = useBuySellModalContext();
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedPosition, setSelectedPosition] = useState(null);
    const [modalAction, setModalAction] = useState(null);

    const handleExitModal = (trades, index) => {
        console.log("Clicked");
        const trade_data = trades[index];
        const sortedTrades = trades.slice().sort((a, b) => {
            if (a.net_quantity === 0 && b.net_quantity === 0) {
                return 0;
            } else if (a.net_quantity === 0) {
                return 1;
            } else if (b.net_quantity === 0) {
                return -1;
            } else {
                return a.net_quantity - b.net_quantity;
            }
        });

        const sortedTradeData = sortedTrades[index];
        const ltpPrice = symbolData[sortedTradeData?.code]?.ltp;
        const data_object = {
            side: sortedTradeData.isBuy ? "Buy" : "Sell",
            instrumentName: sortedTradeData.instrument_name,
            lotSize: sortedTradeData.lotSize / sortedTradeData.lotSize,
            lot_size: sortedTradeData.lotSize,
            productType: sortedTradeData.product_type,
            tradingSymbol: sortedTradeData.tradingSymbol,
            expiryDate: sortedTradeData.expiry_date,
            code: sortedTradeData.code,
            price: ltpPrice || 0,
            trigger_price: ltpPrice || 0,
            buy_sell: sortedTradeData.isBuy ? "S" : "B",
            underlying_code: sortedTradeData.underlying_symbol,
            strike: sortedTradeData.strike,
            quantity: sortedTradeData.lotSize,
            exchange: sortedTradeData.exchange,
            scrip: sortedTradeData.scrip,
            lot_multiplier: sortedTradeData.lotSize,
            // trigger_price: sortedTradeData.ltp,
        };

        setBuySellModalData([data_object]);
        setModalAction("add");
        setModalOpen(true);
    };

    const handleAddModal = (trades, index) => {
        const trade_data = trades[index];
        const sortedTrades = trades.slice().sort((a, b) => {
            if (a.net_quantity === 0 && b.net_quantity === 0) {
                return 0;
            } else if (a.net_quantity === 0) {
                return 1;
            } else if (b.net_quantity === 0) {
                return -1;
            } else {
                return a.net_quantity - b.net_quantity;
            }
        });

        const sortedTradeData = sortedTrades[index];
        const ltpPrice = symbolData[sortedTradeData?.code]?.ltp;
        const data_object = {
            side: sortedTradeData.isBuy ? "Buy" : "Sell",
            instrumentName: sortedTradeData.instrument_name,
            lotSize: sortedTradeData.lotSize / sortedTradeData.lotSize,
            lot_size: sortedTradeData.lotSize,
            productType: sortedTradeData.product_type,
            tradingSymbol: sortedTradeData.tradingSymbol,
            expiryDate: sortedTradeData.expiry_date,
            code: sortedTradeData.code,
            price: ltpPrice || 0,
            trigger_price: ltpPrice || 0,
            buy_sell: sortedTradeData.isBuy ? "B" : "S",
            underlying_code: sortedTradeData.underlying_symbol,
            strike: sortedTradeData.strike,
            quantity: sortedTradeData.lotSize,
            exchange: sortedTradeData.exchange,
            scrip: sortedTradeData.scrip,
            lot_multiplier: sortedTradeData.lotSize,
            // trigger_price: sortedTradeData.ltp,
        };

        setBuySellModalData([data_object]);
        setModalAction("add");
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedPosition(null);
    };

    const fetchOrders = () => {
        console.log("Fetching updated orders");
    };

    // Handle select all checkbox
    const handleSelectAll = (event) => {
        const sortedPositions = positions.slice().sort((a, b) => {
            if (a.net_quantity === 0 && b.net_quantity === 0) {
                return 0;
            } else if (a.net_quantity === 0) {
                return 1;
            } else if (b.net_quantity === 0) {
                return -1;
            } else {
                return a.net_quantity - b.net_quantity;
            }
        });

        const selectablePositions = sortedPositions.filter(pos => pos.net_quantity !== 0);
        const allSelected = selectablePositions.length > 0 && selectablePositions.every(pos => pos.selected);

        // If all are selected, unselect all. Otherwise, select all
        const shouldSelect = !allSelected;

        // Only toggle positions that need to be changed
        sortedPositions.forEach((position, index) => {
            if (position.net_quantity !== 0 && position.selected !== shouldSelect) {
                handleCheckboxChange(activeButton, mainIndex, index);
            }
        });
    };

    // Check if all selectable positions are selected
    const areAllSelected = () => {
        const sortedPositions = positions.slice().sort((a, b) => {
            if (a.net_quantity === 0 && b.net_quantity === 0) {
                return 0;
            } else if (a.net_quantity === 0) {
                return 1;
            } else if (b.net_quantity === 0) {
                return -1;
            } else {
                return a.net_quantity - b.net_quantity;
            }
        });
        const selectablePositions = sortedPositions.filter(pos => pos.net_quantity !== 0);
        return selectablePositions.length > 0 && selectablePositions.every(pos => pos.selected);
    };

    // Check if some positions are selected (for indeterminate state)
    const areSomeSelected = () => {
        // Always return false to keep checkbox empty when less than all are selected
        return false;
    };

    return (
        <div>
            <table className="w-full">
                <thead className="bg-n000 h-9 text-n500 font-medium text-xs border border-n100">
                    <tr className="text-center ">
                        <td>
                            <input
                                type="checkbox"
                                checked={areAllSelected()}
                                ref={(input) => {
                                    if (input) input.indeterminate = areSomeSelected();
                                }}
                                onChange={handleSelectAll}
                            />
                        </td>
                        <td className="text-start">Instruments</td>
                        <td>B/S</td>
                        <td>Expiry</td>
                        <td>Product</td>
                        <td>Quanity</td>
                        <td>Avg price</td>
                        <td>LTP</td>
                        <td className="w-24"> <div className="mr-2 text-right">P&L</div></td>
                    </tr>
                </thead>
                <tbody>
                    {positions &&
                        positions
                            .slice()
                            .sort((a, b) => {
                                if (a.net_quantity === 0 && b.net_quantity === 0) {
                                    return 0;
                                } else if (a.net_quantity === 0) {
                                    return 1;
                                } else if (b.net_quantity === 0) {
                                    return -1;
                                } else {
                                    return a.net_quantity - b.net_quantity;
                                }
                            })
                            .map((obj, row_index) => (
                                <tr
                                    className={`position-table-row text-center h-9  ${obj.net_quantity === 0 ? "disabled-pos-row" : ""
                                        }`}
                                    key={row_index}
                                    onMouseEnter={() => handleRowMouseEnter(row_index, currentGroupIndex)}
                                    onMouseLeave={handleRowMouseLeave}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={obj.selected}
                                            onChange={() =>
                                                handleCheckboxChange(activeButton, mainIndex, row_index)
                                            }
                                            disabled={obj.net_quantity === 0}
                                        />
                                    </td>
                                    <td className="text-start text-p300 text-xs font-medium">
                                        {obj.instrument_name}
                                        {hoveredRowIndex === row_index && currentGroupIndex === mainIndex && visibility && (
                                            <div className="virtual-position-buttons ">
                                                <button
                                                    onClick={() => handleAddModal(positions, row_index)}
                                                    className={`border-none p-0 m-0 w-14 h-6 rounded-[4px] text-xs text-white ${obj.isBuy ? "bg-p150" : "bg-red"
                                                        }`}>
                                                    Add
                                                </button>
                                                <button
                                                    onClick={() => handleExitModal(positions, row_index)}
                                                    className="border-none bg-swipe-button p-0 m-0 w-14 h-6 rounded-[4px] text-xs text-p400">
                                                    Exit
                                                </button>
                                            </div>
                                        )}
                                    </td>
                                    <td
                                        className={`text-xs font-semibold ${obj.net_quantity === 0
                                            ? "disabled-text"
                                            : obj.isBuy
                                                ? "text-p150"
                                                : "text-red"
                                            }`}>
                                        {obj.net_quantity === 0 ? "-" : obj.isBuy ? "BUY" : "SELL"}
                                    </td>
                                    <td className="text-n500 font-semibold text-xs">
                                        {obj.expiry_date}
                                    </td>
                                    <td className="flex items-center justify-center my-1">
                                        <div
                                            className={`text-center px-2 py-1 text-xs font-medium ${obj.product_type === "Normal"
                                                ? "bg-[#E2EBF6] text-[#0075FF]"
                                                : obj.product_type === "Intraday"
                                                    ? "bg-n100 text-n700"
                                                    : ""
                                                }`}>
                                            {obj.product_type === "Normal"
                                                ? "NRML"
                                                : obj.product_type === "Intraday"
                                                    ? "MIS"
                                                    : obj.product_type}
                                        </div>
                                    </td>

                                    <td className="text-n500 text-xs font-semibold">
                                        {obj.net_quantity}
                                    </td>
                                    <td className="text-n700 font-medium text-xs">
                                        {(() => {
                                            const [whole, decimal] = String(obj.average_prc).split(".");
                                            return (
                                                <>
                                                    {whole}
                                                    {decimal !== undefined && (
                                                        <>
                                                            .<span style={{ fontWeight: 400 }}>{decimal}</span>
                                                        </>
                                                    )}
                                                </>
                                            );
                                        })()}
                                    </td>

                                    <td className="text-n700 font-medium text-xs">
                                        {String(symbolData[obj.code]?.ltp).split(".")[0]}.
                                        <span style={{ fontWeight: 400 }}>
                                            {String(symbolData[obj.code]?.ltp).split(".")[1]}
                                        </span>
                                    </td>
                                    <td className="text-xs fw-medium text-right min-w-24">
                                        <div
                                            className={`py-1 px-2 inline-block mr-2 ${parseFloat(
                                                obj.realised_pl +
                                                (symbolData[obj.code]?.ltp - obj.average_prc) *
                                                obj.net_quantity
                                            ) > 0
                                                ? "bg-p150 text-p400"
                                                : "bg-red text-p400"
                                                }`}>
                                            {formatNumberWithFontWeight(
                                                obj.realised_pl +
                                                (symbolData[obj.code]?.ltp - obj.average_prc) *
                                                obj.net_quantity
                                            )}
                                        </div>
                                    </td>

                                </tr>
                            ))}
                </tbody>
            </table>

            {/* BuySell Modal */}
            {modalOpen && (
                <BuySellModal
                    modalOpen={modalOpen}
                    modalClose={closeModal}
                    isOrders={true}
                    setIsBuySellModalOpen={setModalOpen}
                    fetchOrders={fetchOrders}
                    initialData={selectedPosition}
                    action={modalAction}
                />
            )}
        </div>
    );
};

export default PositionsTable;